import React, { useEffect, useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  CustomCalendar,
  CustomDataTableHeader,
  CustomPanel,
  Loading,
  PageHeader,
  SelectEmpresas,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import useHistoricoLeituraLote from './HistoricoLeituraLoteState'

function HistoricoLeituraLote({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useHistoricoLeituraLote()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetMessage()
    }
  }, [state.errorMessage])

  const handleBuscar = () => {
    localDispatch.buscarDados(selectedTp)
  }

  const handleExportarExcel = () => {
    localDispatch.exportarExcel()
  }

  const header = useMemo(
    () => (
      <CustomDataTableHeader
        title="Histórico de Leitura por Período Por Lote"
        onChange={value => setGlobalFilter(value)}
      />
    ),
    [],
  )

  const empresaId = state.selectedEmpresa ? state.selectedEmpresa.id : ''

  return (
    <>
      <PageHeader>4.7 - Histórico de Leitura por Período Por Lote</PageHeader>

      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid p-align-center" style={{ marginBottom: 20 }}>
            <div className="p-col-2">
              <CustomCalendar
                label="Período Inicial"
                value={state.periodo.dataInicial}
                onChange={value => localDispatch.onPeriodoInicialChange(value)}
              />
            </div>
            <div className="p-col-2">
              <CustomCalendar
                label="Período Final"
                value={state.periodo.dataFinal}
                onChange={value => localDispatch.onPeriodoFinalChange(value)}
              />
            </div>

            <div className="p-col-3">
              <SelectEmpresas
                companyId={empresaId}
                onChange={value => localDispatch.setSelectedEmpresa(value)}
              />
            </div>

            <div className="p-col-3" style={{ marginTop: 27 }}>
              <Btn
                disabled={!selectedTp || !empresaId}
                isLoading={state.isLoading}
                onClick={handleBuscar}
              >
                Buscar
              </Btn>
              <Btn
                disabled={!selectedTp || !empresaId || state.data.length === 0}
                onClick={handleExportarExcel}
                style={{ display: 'inline-block', marginLeft: 16 }}
              >
                Exportar Excel
              </Btn>
            </div>
          </div>

          {state.isLoading ? (
            <div className="text-center" style={{ marginTop: 20 }}>
              <Loading />
            </div>
          ) : (
            <DataTable
              value={state.data}
              rows={15}
              paginator
              header={header}
              globalFilter={globalFilter}
              emptyMessage="Nenhum registro encontrado"
            >
              <Column
                field="codigo_produto"
                header="Código Produto"
                style={tableCellCentered(150)}
                sortable
              />
              <Column field="descricao" header="Descrição" sortable />
              <Column
                field="quantidade"
                header="Quantidade"
                style={tableCellCentered(120)}
                sortable
              />
              <Column field="lote" header="Lote" style={tableCellCentered(150)} sortable />
              <Column
                field="referencia"
                header="Num. Referência"
                style={tableCellCentered(150)}
                sortable
              />
              <Column field="observacao" header="Observação" sortable />
            </DataTable>
          )}
        </CustomPanel>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(HistoricoLeituraLote))
